import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../../utils/liffHelper';
import { Redirect } from 'react-router-dom'
import Noredi from './ProfileNoredi'
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import InputLabel from '@material-ui/core/InputLabel';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(3, 2)
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: {
        type: this.props.location.state.type,
        viewType: this.props.location.state.viewType,
        userId: this.props.location.state.userId,
        utouId: this.props.location.state.utouId,
        roomId: this.props.location.state.roomId,
        groupId: this.props.location.state.groupId,
        displayName: this.props.location.state.displayName,
        pictureUrl: this.props.location.state.pictureUrl,
      },
      mongo: {
        Ck_Name: 'false'
      },
      redi: {
        redirect: false,
        redirectnogroup: false
      },
      keep: {
        password: this.props.location.state.password,
      },
      datafrom: {
        brace: ''
      },
      LinkG: '',
      Ck_NameF: 'FFFFF',
      Ck_NameL: '',
      stacheck: {
        stacheck2: false
      },
      openS: false,
      openW: false,
      openZ: false,
      showselectadm: false,
      idfb: false,
      showselectname: false,
      showselect: false,
      selected: '',
      groupold: '',
      CusIDem: ''
    };


  }
  async componentDidMount() {

    // const profile = await liffHelper.initcontext()
    // const profile = await liffHelper.getProfile()
    // alert(profile.groupId)
    // this.setState({
    //   profile: {
    //     userId: profile.userId,
    //     groupId: profile.groupId,
    //     displayName: "DisplayName: " + profile.displayName,
    //     pictureUrl: profile.pictureUrl
    //   }
    // })
    // const adm = await liffHelper.getgroup(this.props.location.state.groupId)
    // // alert(adm)
    // if (adm != undefined) {
    //   // alert(adm.group_name)
    //   // alert(this.state.data)
    //   this.setState({
    //     groupold: adm.group_name,
    //     openZ: true
    //   });
    // }
    // const nna = await liffHelper.listline(1000)
    // // alert(nna)
    // if (nna != undefined) {
    //   // alert(nna[0].Ck_NameF)
    //   // alert(this.state.data)
    //   this.setState({
    //     showselect: nna
    //   });


    // }


    // }
  }

  closeWindow() {
    liffHelper.closeWindow()
  }


  // renderRedirect = () => {
  //   if (this.state.password.substring(0, 6).toLowerCase() == "cus123") {
  //     alert("123")
  //     return <Redirect
  //       to={{
  //         pathname: '/message',
  //         state: { id: this.state.keep.password }
  //       }}
  //     />
  //   }
  // }

  async handleChange(event) {
    this.setState({ selected: event.target.value });
  };

  async savemongo() {
    if (this.state.CusIDem == '' || this.state.CusIDem == undefined ) {
      alert('required namegroup')
    // }
    // else if (this.state.LinkG == '') {
    //   alert('required linkgroup')
    // }
    // else if (this.state.selected == '') {
    //   alert('required branch')
    // // }else if (this.state.idfb == false) {
    // //   alert('required ID-Fb')
    } else {
    //   if(this.state.groupold == ''){
    this.setState({
      openW: true
    });
    const inss = await liffHelper.insertlineadmin(
      this.state.profile.displayName,
      this.state.profile.userId,
      this.state.CusIDem
    )  
    alert(inss.sta)
    if (inss != undefined) {
      
      if (inss.sta == 'AddSuccess' || inss.sta == 'Success!') {
        // alert(inss.sta)
        this.setState({
          stacheck: {
            ...this.state.stacheck,
            stacheck2: inss.sta,
          },
          openW: false,
          openS: true
        })
      } else {
        alert('มีข้อผิดพลาด ลองใหม่')
      }
    }
  }
  }
  // else if(this.state.groupold != ''){
  //   this.setState({
  //     openW: true
  //   });
  //   const inss = await liffHelper.updategroup(
  //     this.state.profile.displayName,
  //     this.state.profile.groupId,
  //     this.state.Ck_NameF,
  //     this.state.LinkG,
  //     this.state.selected,
  //   )
  //   if (inss != undefined) {
  //     if (inss.status == 'UpdateSuccess') {
  //       // alert(inss.sta)
  //       this.setState({
  //         stacheck: {
  //           ...this.state.stacheck,
  //           stacheck2: inss.sta,
  //         },
  //         openW: false,
  //         openS: true
  //       })
  //     } else {
  //       alert('อัปเดท มีข้อผิดพลาด ลองใหม่')
  //     }
  //   }
  // }
  // }
  // }
  // Changbance(event) {
  //   alert(event.target.value)
  //   this.setState({ datafrom: { brace: event.target.value } });
  //   // alert(this.state.datafrom.brace)
  // }
  // async handleChangeadm(event) {

  //  const monget = await liffHelper.mongget(event.target.name) 
  // alert(event.target.value)
  // alert(event.target.value[0])
  // alert(event.target.value)
  // let v1 = event.target.value[0]
  // const checkin = await liffHelper.checkin(v1)
  //   this.setState({ showselectname: event.target.value });
  //   // alert(this.state.namecus)
  // }
  // async SearchOther() {
  //   const fb = await liffHelper.getidfb(this.state.showselectname)
  //   // alert(nna)
  //   if (fb != undefined) {
  //     if (fb.ussr != undefined) {
  //       this.setState({
  //         idfb: fb.ussr
  //       });
  //       alert('Search Finish')
  //     } else if(fb.status != undefined) {
  //       alert(fb.status)
  //     } else {
  //       alert('error No status Please contact ก๊อต-AGS')
  //     }      
  //   }
  // }

  render() {
    const classes = this.props;

    return (
      // <div className={classes.root}>
      // <div>
      //   <Noredi />

      <div className={classes.root} >
        <Noredi />
        {/* {this.renderRedirect()} */}
        <Paper className={classes.paper} style={{ marginTop: 10, padding: 30 }}>
          <CssBaseline />
          <div className={classes.paper} >
            {/* <Avatar className={classes.avatar} src={this.state.profile.pictureUrl} /> */}

            {/* </Avatar> */}
            <Typography component="h1" variant="h5">
              Regis Admin
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={"Admin: " + this.state.profile.displayName}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                // id="email"
                // label="Admin Messenger Rafco"
                label="รหัสสมาชิก"
                name="รหัสสมาชิก"
                autoComplete="รหัสสมาชิก"
                autoFocus
                onChange={event => this.setState({ CusIDem: event.target.value })}
              // disabled="disabled"
              />
              <Dialog
                open={this.state.openW}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <CircularProgress />
                    <CircularProgress color="secondary" />
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* <Button  color="primary">
                    Disagree
                  </Button>
                  <Button  color="primary" autoFocus>
                    Agree
                  </Button> */}
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openS}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                {/* <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle> */}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    RegisAdmin {this.state.stacheck.stacheck2}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" onClick={event => this.setState({ openS: false })}>
                    Retry
                  </Button>
                  <Button color="primary" autoFocus onClick={this.closeWindow.bind(this)}>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openZ}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                {/* <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle> */}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    กลุ่มนี้เคยลงทะเบียนแล้ว ชื่อ: {this.state.groupold}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" autoFocus onClick={this.closeWindow.bind(this)}>
                    ยกเลิก
                  </Button>
                  <Button color="primary" onClick={event => this.setState({ openZ: false })}>
                    อัปเดท
                  </Button>
                </DialogActions>
              </Dialog>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.profile.userId}
                // label={this.state.stacheck.stacheck2}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              <Button variant="outlined" color="primary" onClick={this.savemongo.bind(this)}>
                SAVE
              </Button>
            </form>
          </div>
          <h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1>
        </Paper>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// src/pages/components/LineRegis.js